import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { empresaClienteColumns } from './columns/_columns'
import { ClienteList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const EmpresasClienteTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => empresaClienteColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum empregador encontrado para “${filters.nome.trim()}”`}
      description='Revise o termo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum empregador ASO cadastrado'
      description='Use “Adicionar” para cadastrar o primeiro empregador.'
    />
  )

  return (
    <CustomTable<ClienteList>
      id='kt_table_empresa_cliente'
      ariaLabel='Empregadores ASO'
      itemLabel={{ singular: 'empregador', plural: 'empregadores' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
